import { Component, ContentChild, ElementRef, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ObservableInput } from 'ngx-observable-input';
import { combineLatest, interval, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GraphQlQuery, GraphQlResultsSeriesOptions, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';




@Component({
  selector: 'graphql',
  templateUrl: './graphql.component.html',
})
export class GraphQlComponent implements OnInit, OnDestroy {



  @ObservableInput()
  @Input("query")
  query$: Observable<GraphQlQuery>;

  @ObservableInput()
  @Input("options")
  options$: Observable<GraphQlResultsSeriesOptions>;

  @ContentChild('resultsTemplate') resultsTemplate: TemplateRef<any>;
  @ContentChild('loadingTemplate') loadingTemplate: TemplateRef<any>;

  results: Observable<any>;


  

  constructor(public graphQlService: IGraphQlService) {


  }



  ngOnInit() {
    this.results = combineLatest(this.query$, this.options$).pipe(
      switchMap(([query, options]) => {
        return this.graphQlService.getGraphQlResultsSeries(query, options);
      })
    );
  }

  ngOnDestroy() {
    
  }




  onSelect(data): void {
  }

  onActivate(data): void {
  }

  onDeactivate(data): void {
  }
}
